(function (window, document) {
  "use strict";

  var registeredVideos = new WeakSet();
  var visibleRatios = new Map();
  var mobileViewport = window.matchMedia("(max-width: 640px)");
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var connection = window.navigator && (
    window.navigator.connection ||
    window.navigator.mozConnection ||
    window.navigator.webkitConnection
  );

  function constrainedPlayback() {
    return mobileViewport.matches ||
      reducedMotion.matches ||
      Boolean(connection && connection.saveData);
  }

  function normalizeVideo(video) {
    video.autoplay = false;
    video.removeAttribute("autoplay");
    video.preload = "none";
    video.setAttribute("preload", "none");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.muted = true;
    if (window.MarlotVideoPlaybackCoordinator) {
      window.MarlotVideoPlaybackCoordinator.register(video);
    }
  }

  function syncPlayback() {
    var target = null;
    var targetRatio = 0;

    if (!document.hidden && !constrainedPlayback()) {
      visibleRatios.forEach(function (ratio, video) {
        if (!video.isConnected) {
          visibleRatios.delete(video);
          return;
        }
        if (ratio >= 0.5 && ratio > targetRatio) {
          target = video;
          targetRatio = ratio;
        }
      });
    }

    visibleRatios.forEach(function (_ratio, video) {
      if (video !== target) video.pause();
    });

    if (target && target.paused && window.MarlotVideoPlaybackCoordinator) {
      window.MarlotVideoPlaybackCoordinator.requestPlay(target);
    }
  }

  var observer = "IntersectionObserver" in window
    ? new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visibleRatios.set(
          entry.target,
          entry.isIntersecting ? entry.intersectionRatio : 0
        );
      });
      syncPlayback();
    }, { threshold: [0, 0.5, 0.75, 1] })
    : null;

  function registerVideo(video) {
    if (!video || registeredVideos.has(video)) return;
    registeredVideos.add(video);
    visibleRatios.set(video, 0);
    normalizeVideo(video);
    if (observer) observer.observe(video);
  }

  function registerWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(".js-ambient-video")) registerVideo(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(
        root.querySelectorAll(".js-ambient-video"),
        registerVideo
      );
    }
  }

  function init() {
    registerWithin(document);

    if ("MutationObserver" in window && document.body) {
      var mutationObserver = new window.MutationObserver(function (records) {
        records.forEach(function (record) {
          Array.prototype.forEach.call(record.addedNodes || [], registerWithin);
        });
      });
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    syncPlayback();
  }

  document.addEventListener("visibilitychange", syncPlayback);
  document.addEventListener("shopify:section:load", function (event) {
    registerWithin(event.target);
    syncPlayback();
  });

  [mobileViewport, reducedMotion].forEach(function (mediaQuery) {
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", syncPlayback);
    } else if (typeof mediaQuery.addListener === "function") {
      mediaQuery.addListener(syncPlayback);
    }
  });
  if (connection && typeof connection.addEventListener === "function") {
    connection.addEventListener("change", syncPlayback);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(window, document);
